import { pxToEm, themeV2 } from '@insticator/insticator-ui'

/* ++++++++++ --------------- ROLE FORM : STYLES --------------- ++++++++++ */
export default {
  roleform: {
    position: 'relative',
    zIndex: 4,
    '& .sectioncard': {
      padding: `${pxToEm(32)} !important`,
      border: 0
    },
    '& label': {
      display: 'flex',
      color: themeV2.color.primary.main
    },
    '& .errormessage': {
      opacity: '0',
      display: 'block',
      color: themeV2.color.error.main,
      fontSize: pxToEm(14),
      marginTop: pxToEm(5),
      // animate in 
      animationName: 'fadeInDown',
      animationDelay: '0s',
      animationDuration: '.1s',
      animationFillMode: 'forwards'
    },
    '& .roleformtitle': {
      margin: `${pxToEm(8)} 0 ${pxToEm(24)}`
    },
    ['& img.badgeimg, & .preview']: {
      width: pxToEm(40),
      height: pxToEm(40),
      borderRadius: pxToEm(8),
      '&.hidden-true': {
        display: 'none'
      },
    },
    '& .name-imgactiongrp': {
      display: 'flex',
      justifyContent: 'center',
      marginLeft: pxToEm(8),
      '& .button': {
        margin: `0 ${pxToEm(8)}`,
        width: '100%'
      }
    },
    ['& .name-badgeimggrp, & .name-uploadimggrp']: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: pxToEm(240),
      alignItems: 'center',
      '&.show-false': {
        display: 'none'
      },
      '& .name-imgactionbtn': {
        marginLeft: pxToEm(16),
        maxWidth: pxToEm(80)
      }
    },
    '& .name-rolenamegrid': {
      marginRight: `${pxToEm(48)} !important`
    },
    '& .avatarfield': {
      display: 'flex',
      alignItems: 'center',
      '&.show-upload-img': {
        alignItems: 'flex-start'
      },
      '& .imageuploader': {
        display: 'flex',
        flexDirection: 'row-reverse',
        maxWidth: pxToEm(240),
        '& .imagepreview': {
          marginTop: 0
        },
        '& button': {
          maxWidth: pxToEm(150)
        },
        '& input.mainImageInput': {
          maxWidth: pxToEm(150)
        },
        '& .nofiletext': {
          textAlign: 'left',
          marginTop: pxToEm(4)
        }
      }
    }
  }
}; 